export default class {

    /**
     * get
     * @param {String} name パラメータ名
     * @param {String} url 値を取得するURL。無い場合は現在のURLから取得する。
     */
    get(name, url){
        if (!url) { url = window.location.href };
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
        if (!results) { return null };
        if (!results[2]) { return '' };
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * getList
     * @param {String} url 値を取得するURL。無い場合は現在のURLから取得する。
     */
    getList(url){
		if (!url) { url = window.location.href };
		let regex = /[?&]([^=#]+)=([^&#]*)/g;
		let params_obj = {};
		let match;
		while(match = regex.exec(url)){
			params_obj[match[1]] = match[2];
		};
		return params_obj;
    }

	/**
     * add
     * @param {String} path 追加元のURL文字列
     * @param {String} key 追加するパラメータのキーの名称
     * @param {String} value 追加するパラメータの値
     * @param {String} save すでに同じパラメータのキーが存在していた場合に上書きをするかどうか
     */
	add(path, key, value, save){
	    if (!path || !key || !value) return '';

	    let addParam      = key + '=' + value,
	        paths         = path.split('/'),
	        fullFileName  = paths.pop(),
	        fileName      = fullFileName.replace(/[\?#].+$/g, ''),
	        dirName       = path.replace(fullFileName, ''),
	        hashMatches   = fullFileName.match(/#([^#]+)$/),
	        paramMatches  = fullFileName.match(/\?([^\?]+)$/),
	        hash          = '',
	        param         = '',
	        params        = [],
	        fullPath      = '',
	        hitParamIndex = -1;

	    if (hashMatches && hashMatches[1]) {
	        hash = hashMatches[1];
	    };

	    if (paramMatches && paramMatches[1]) {
	        param = paramMatches[1].replace(/#[^#]+$/g, '').replace('&', '&');
	    };

	    fullPath = dirName + fileName;

	    if (param === '') {
	        param = addParam;
	    } else if (save) {
	        params = param.split('&');

	        for (let i = 0, len = params.length; i < len; i++) {
	            if (params[i].match(new RegExp('^' + key + '='))) {
	                hitParamIndex = i;
	                break;
	            };
	        };

	        if (hitParamIndex > -1) {
	            params[hitParamIndex] = addParam;
	            param = params.join('&');
	        } else {
	            param += '&' + addParam;
	        };
	    } else {
	        param += '&' + addParam;
	    };

	    fullPath += '?' + param;

	    if (hash !== '') fullPath += '#' + hash;

	    return fullPath;
	}

}